import React from 'react'
import ProjectsListManager from "../../../../core/gd/manager/projects-list-manager"
import NavigationMenuItemProject from "./menu-item-project"
import ProjectsReorderList from "../../sections/projects/projects-reorder-list"
import ArrayUtils from "../../../../core/gd/utils/array"
import {NavigationMenuInlineAddParams, NavigationMenuInlineAddType} from "../menu-add-with-popover/popover"
import ProjectSession from "../../../../core/model2/project/project-session"
import NavigationMenu_ProjectsInlineAdd from "../../sections/projects/tree/inline-add"
import {ProjectSystemType} from "../../../../core/model2/project/types";
import {BUS_APP_LAUNCH} from "../../../../core/gd/app-manager/@event"
import {SpaceProto} from "../../../../core/model2/space/space-proto";

type Props = {
    level                       : number
    localSettings               : any
    expandedProjectsSettingName : string
    project                     : ProjectSession
    space                       : SpaceProto
    dndPreview?                 : boolean
}

// const debug = "NavigationMenuItemProjectWithReorder"
const debug = false

export default class NavigationMenu_ItemProjectWithReorder extends React.Component<Props, any> {

    constructor(props: Props) {
        super(props)

        this.state = {
            addParentId     : null
        }
    }

    componentDidMount() {
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
    }

    onLaunchApp = (data: any) => {
        debug && console.log(debug, 'onLaunchApp() data', data)

        const projectId = data.params?.projectId || data.params?.customViewData?.parentProjectId
        if (projectId) {
            const projectParentsIds = gd.tree.findProjectParents(gd.tree.getProject(projectId)).map((p:any)=>p.id)
            if (projectParentsIds?.includes(this.props.project.id)) {
                const newExpandedItems = _.union(this.props.localSettings[this.props.expandedProjectsSettingName].slice(), projectParentsIds)

                debug && console.log(debug, 'onLaunchApp', projectId, newExpandedItems)

                this.props.localSettings[this.props.expandedProjectsSettingName] = newExpandedItems
                this.props.localSettings.save()
            }
        }

        this.forceUpdate()
    }

    onMenuItemHandleClick = (id: ID, e: any) => {
        e.stopPropagation()

        const newExpandedItems = this.props.localSettings[this.props.expandedProjectsSettingName].slice()
        const index = newExpandedItems.indexOf(id)

        if (index !== -1) {
            newExpandedItems.splice(index, 1)
        } else {
            newExpandedItems.push(id)
        }

        this.props.localSettings[this.props.expandedProjectsSettingName] = newExpandedItems;
        this.props.localSettings.save()

        this.forceUpdate()
    }

    onAddInline = (inlineType: NavigationMenuInlineAddType, parentId: ID, params: NavigationMenuInlineAddParams) => {
        debug && console.log(debug, 'onAddInline', inlineType, parentId, params)

        const expandedProjectIds = this.props.localSettings[this.props.expandedProjectsSettingName]
        this.props.localSettings[this.props.expandedProjectsSettingName] = ArrayUtils.addValueToArray(expandedProjectIds, parentId)
        this.props.localSettings.save()

        this.setState({
            inlineType  : inlineType,
            addParentId : parentId,
            params      : params, // for folder, page and embed
        })
    }

    onInlineAdded = (isAdded: boolean) => {
        debug && console.log(debug, 'onInlineAdded', isAdded)

        // if nothing added and project has no children then collapse it
        if (!isAdded && _.isEmpty(ProjectsListManager.getChildProjects(null, this.state.addParentId))) {
            const expandedProjectIds = this.props.localSettings[this.props.expandedProjectsSettingName]
            this.props.localSettings[this.props.expandedProjectsSettingName] = ArrayUtils.removeValueFromArray(expandedProjectIds, this.state.addParentId)
            this.props.localSettings.save()
        }

        this.setState({
            inlineType  : null,
            addParentId : null,
            params      : null,
        })
    }

    renderListItems(level: number, parent: any | null, submenu: any[]) {

        debug && console.log(debug, "renderListItems() props.project=",this.props.project," level=", level, "parent=", parent, "submenu=", submenu )

        let items : ProjectSession[] = []
        if (!parent) {
            debug && console.log(debug, "    no parent. props.project = ", this.props.project)



            // const projToAdd = gd.tree.getProject(this.props.projectId)
            // if (projToAdd) items.push(projToAdd)
            // else console.error("??? can't find project for pin", this.props.projectId)

            items.push(this.props.project)


        } else {
            // items = ProjectsListManager.getChildProjects(null, parent.id)
            items = this.props.project.treeChildren
        }

        if (items && items.length > 0) {
            items.map((listItem: ProjectSession)=> {

                const isExpanded : boolean = this.props.localSettings[this.props.expandedProjectsSettingName].includes(listItem.id) && listItem.hasAccessibleChildren
                const showChildProjects = isExpanded && listItem.treeChildren && listItem.hasAccessibleChildren
                const showInlineAdd = this.state.addParentId === listItem.id
                const fragment = gd.router.history.fragment || ''
                const isSelected = _.startsWith(fragment, 'p/') && fragment.includes(listItem.id)

                // Esli eto report, ne pokazivaem
                if(listItem.systemType === ProjectSystemType.REPORT_VIEW) return

                submenu.push(<NavigationMenuItemProject key                     = {listItem.id}
                                                        project                 = {listItem}
                                                        isSelected              = {isSelected}
                                                        isExpanded              = {isExpanded}
                                                        level                   = {level}
                                                        colorized               = {this.props.space.projectsColorize}
                                                        onMenuItemHandleClick   = {this.onMenuItemHandleClick}
                                                        onAddInline             = {this.onAddInline}/>)

                if (showChildProjects) {
                    submenu.push(<ProjectsReorderList key               = {'list_'+listItem.id}
                                                      space             = {this.props.space}
                                                      level             = {level+1}
                                                      parentId          = {listItem.id}
                                                      projects          = {listItem.treeChildren}
                                                      localSettings     = {this.props.localSettings}/>)
                }

                if (showInlineAdd) {
                    submenu.push(<NavigationMenu_ProjectsInlineAdd key      = {'add_{0}'.f(listItem.id)}
                                                                   type     = {this.state.inlineType}
                                                                   level    = {level+1}
                                                                   parentId = {this.state.addParentId}
                                                                   params   = {this.state.params}
                                                                   callback = {this.onInlineAdded}/>)
                }
            })
        }
    }

    render() {
        const submenu: any[] = []
        this.renderListItems(this.props.level, null, submenu)

        const classes = Classes("root-pinned-project-container with-reorder", {
            'dnd-preview': this.props.dndPreview,
        })

        return (
            <div className={classes}>
                {submenu}
            </div>
        )
    }
}
